var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 5,
    fill: "#FFEFEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0031 25.0132C57.8327 24.9956 57.661 24.9956 57.4906 25.0132H22.4906C22.2663 25.0166 22.0435 25.0502 21.8281 25.1131L39.8906 43.0928L58.0031 25.0132Z",
    fill: "#C2775B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.85 26.7498L41.65 44.8669C41.1816 45.3323 40.548 45.5936 39.8875 45.5936C39.227 45.5936 38.5934 45.3323 38.125 44.8669L20.0875 26.8872C20.032 27.0909 20.0026 27.3008 20 27.5119V52.5011C20 53.1639 20.2634 53.7995 20.7322 54.2681C21.2011 54.7367 21.837 55 22.5 55H57.5C58.163 55 58.7989 54.7367 59.2678 54.2681C59.7366 53.7995 60 53.1639 60 52.5011V27.5119C59.9901 27.2516 59.9394 26.9944 59.85 26.7498ZM24.2125 52.5011H22.475V50.7144L31.5625 41.7058L33.325 43.4675L24.2125 52.5011ZM57.475 52.5011H55.725L46.6125 43.4675L48.375 41.7058L57.4625 50.7144L57.475 52.5011Z",
    fill: "#C2775B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.e6cbd1a1ec9ee09bf9a2357dca59300d.svg";
export { ForwardRef as ReactComponent };